import { Dialog } from 'primereact/dialog'
import React from 'react'
import DialogFooter from '../dialogFooter'
import { Button } from 'primereact/button'
import TiposDeRecebimentoTable from '../../views/tiposDeRecebimento/tiposDeRecebimentoTable'
import AuthService from '../../app/service/authService'
import TiposDeRecebimentoService from '../../app/service/tiposDeRecebimentoService'
import ConstantsUtil from '../../context/constantsUtil'
import HandleErrorService from '../../app/service/handleErrorService'

class CadastrarTipoDeRecebimentoSimplesDialog extends React.Component {

    constructor(){
        super()
        this.tiposDeRecebimentoService = new TiposDeRecebimentoService()
        
    }

    state = {

        nomeTipoDeRecebimentoASerCriado: '',
        inputCreateTipoDeRecebimentoErrorClass: '',

    }

    checkDataCreateTipoDeRecebimento = () => {
        var check = true
        if(!this.state.nomeTipoDeRecebimentoASerCriado){
            this.setState({inputCreateTipoDeRecebimentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }
        return check
    }    

    callSaveCreateTipoDeRecebimento = () => {
        this.setState({inputCreateTipoDeRecebimentoErrorClass: ''})
        if(this.checkDataCreateTipoDeRecebimento()){
            AuthService.startBlockUi()
            this.tiposDeRecebimentoService.createSimples({nomeTipoDeRecebimento: this.state.nomeTipoDeRecebimentoASerCriado})
            .then(response => {
                this.hideCreateTipoDeRecebimentoDialog()
                this.props.search()
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
            .finally(() => {
                AuthService.stopBlockUi()
            })
        }
    }

    hideCreateTipoDeRecebimentoDialog = () => {
        this.setState({nomeTipoDeRecebimentoASerCriado: ''})
        this.props.hideDialog()
    }

    render(){

        const createFooter = (
            <DialogFooter
                save = {this.callSaveCreateTipoDeRecebimento}
                hideDialog = {this.hideCreateTipoDeRecebimentoDialog}
            />
        )

        return(
            <>

                <Dialog
                    // visible={this.state.displayCadastroTipoDeRecebimentoDialog}
                    visible={this.props.visible}
                    header={"Cadastrar Tipo de Recebimento Simples"}
                    modal
                    style={{ width: '550px' }}
                    onHide={this.hideCreateTipoDeRecebimentoDialog}
                    footer={createFooter}                
                >
                    <div style={{color: "red", fontSize: "0.8rem"}}>
                        Ao criar um Tipo de Recebimento por esse atalho, ele será criado com os seguintes parâmetros:
                        <div style={{marginLeft: '20px', marginBottom: '10px'}}>
                            <li>Natureza: Outros.</li>
                            <li>Taxa: 0.</li>
                            <li>Prazo: 0.</li>
                            <li>Tipo De Corte: dia do lançamento.</li>
                        </div>
                        Caso deseje utilizar outros parâmetros, então crie através do menu Cadastros -&gt; Tipos de Recebimento.
                    </div>

                    <br />

                    <label htmlFor="date">Nome</label>
                    <input
                        type="text"
                        className={"form-control " + this.state.inputCreateTipoDeRecebimentoErrorClass}
                        value = {this.state.nomeTipoDeRecebimento}
                        autoFocus
                        name="nomeTipoDeRecebimentoASerCriado"
                        onChange={event => this.setState({nomeTipoDeRecebimentoASerCriado: event.target.value})}
                    />
                    <div className="invalid-feedback">{"Informe o nome"}</div>                    
                </Dialog>

            </>
        )

    }

}


export default CadastrarTipoDeRecebimentoSimplesDialog